import { useState, useEffect, useCallback } from "react";
import { BrowserProvider } from "ethers";
import { networks } from "../../networks";

const useWalletConnect = () => {
  const [address, setAddress] = useState("");
  const [network, setNetwork] = useState(null);
  const [provider, setProvider] = useState(null);

  const handleAccountsChanged = async (accounts) => {
    if (accounts.length > 0) {
      setAddress(accounts[0]);
      const newProvider = new BrowserProvider(window.ethereum);
      setProvider(newProvider);
      const network = await newProvider.getNetwork();
      setNetwork(network);
    } else {
      setAddress("");
      setNetwork(null);
      setProvider(null);
    }
  };

  const handleChainChanged = () => {
    window.location.reload();
  };

  useEffect(() => {
    const checkExistingConnection = async () => {
      if (window.ethereum) {
        try {
          const accounts = await window.ethereum.request({ method: 'eth_accounts' });
          if (accounts.length > 0) {
            handleAccountsChanged(accounts);
          }
        } catch (error) {
          console.error("Error checking for existing connection:", error);
        }
      }
    };
    checkExistingConnection();
  }, []);

  const connectWallet = useCallback(async (networkName) => {
    if (window.ethereum) {
      try {
        if (networkName && networks[networkName]) {
          try {
            await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: networks[networkName].chainId }],
            });
          } catch (switchError) {
            // This error code indicates that the chain has not been added to MetaMask.
            if (switchError.code === 4902) {
              try {
                await window.ethereum.request({
                  method: 'wallet_addEthereumChain',
                  params: [networks[networkName]],
                });
              } catch (addError) {
                console.error('Could not add network:', addError);
              }
            }
            console.error('Could not switch network:', switchError);
          }
        }

        const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
        if (accounts && accounts.length > 0) {
          handleAccountsChanged(accounts);
        }
      } catch (error) {
        console.error("Error al conectar la wallet:", error);
      }
    } else {
      alert("MetaMask no está instalado.");
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("walletProvider")) {
      connectWallet();
    }
  }, [connectWallet]);

    const onDisconnect = useCallback(() => {
        setAddress(null);
        setNetwork(null);
        setProvider(null);
        localStorage.removeItem("walletProvider");
    }, []);

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", handleAccountsChanged);
      window.ethereum.on("chainChanged", handleChainChanged);

      return () => {
        window.ethereum.removeListener("accountsChanged", handleAccountsChanged);
        window.ethereum.removeListener("chainChanged", handleChainChanged);
      };
    }
  }, []);

  return { address, network, provider, connectWallet, onDisconnect };
};

export default useWalletConnect;